import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Component({
  selector: 'app-loginpage',
  templateUrl: './loginpage.component.html',
  styleUrls: ['./loginpage.component.css'],
})
export class LoginpageComponent {
  login: any = {};
  constructor(private router: Router, private msalservice: MsalService) {}
  isloggedin(): boolean {
    return this.msalservice.instance.getActiveAccount() != null;
  }

  loginpage(e: any) {
    e.preventDefault();
    this.msalservice
      .loginPopup()
      .subscribe((Response: AuthenticationResult) => {
        this.msalservice.instance.setActiveAccount(Response.account);
        this.router.navigate(['/devopsoutageform']);
      });
  }
}
